module.exports = __webpack_public_path__ + "img/signin-logo.094967ce.png";